import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 0 1rem;
`;

const VideoWrapper = styled.div`
  min-width: 77%;

  @media (max-width: 768px) {
    min-width: 100% !important;
  }
  border-radius: 16px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  background-color: #2a2a2a;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 360px;
  border-radius: 12px;
  @media (min-width: 768px) {
    height: 450px;
  }
  @media (min-width: 1024px) {
    height: 540px;
  }
`;

const VideoSection = () => {
  return (
    <Container>
      <Wrapper>
        <Heading className="manrope-regular">
          <b>
            Glimpse at&nbsp;
            <span>Tackoom</span>
          </b>
        </Heading>
        <VideoWrapper>
          <StyledVideo controls>
            <source src="https://beta.tackoom.com/Tackoom.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </StyledVideo>
        </VideoWrapper>
      </Wrapper>
    </Container>
  );
};

export default VideoSection;

const Heading = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  span {
    color: #ea5d0f;
  }
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
